
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationES from './locales/es/translation.json';
import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';
import translationCA from './locales/ca/translation.json';

const resources = {
    es: {
        translation: translationES
    },
    en: {
        translation: translationEN
    },
    de: {
        translation: translationDE
    },
    ca: {
        translation: translationCA
    }
};

const supportedLngs = ['es', 'en', 'de', 'ca'];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'es',
        supportedLngs,
        nonExplicitSupportedLngs: true,
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        detection: {
            order: ['path', 'navigator'],
            caches: [],
            lookupFromPathIndex: 0,
            convertDetectedLanguage: (lng: string) => lng.split('-')[0]
        }
    });

export default i18n;
